/**
 * Delegation helps in avoiding many event handler for the same elementSelector
 * See more: https://javascript.info/event-delegation
 * Example: delegate('click', '.classname', callbackFunc)
 *
 * @param eventName
 * @param elementSelector
 * @param handler
 */
export function delegate(eventName, elementSelector, handler) {
  document.addEventListener(
    eventName,
    function (e) {
      for (
        let target = e.target;
        target && target != this;
        target = target.parentNode
      ) {
        if (target.matches(elementSelector)) {
          handler.call(target, e, elementSelector);
          break;
        }
      }
    },
    false,
  );
}

export function disablePageScrolling() {
  // The `overflow-hidden` class is applied to both HTML and body elements
  // because there's an issue in iPhone devices. See:
  // https://stackoverflow.com/questions/3047337/does-overflowhidden-applied-to-body-work-on-iphone-safari
  document.querySelector('html').classList.toggle('overflow-hidden');
  document.querySelector('body').classList.toggle('overflow-hidden');
}
